import { useState, useEffect } from "react";
import { Grid, Select } from "~/components/UI";
import BaseCard from "./BaseCard";
import BusinessTransactionCount from "./Charts/BusinessTransactionCount";
import { eTimeInterval } from "./TimeIntervalSelector";
import { useTranslation } from "react-i18next";
import usePermissions from "~/hook/usePermissions";
import { PERMISSION } from "~/api/permissions/enums";
import {
  BUSINESS_TRANSACTIONS_FILTER,
  BUSINESS_TRANSACTIONS_FILTER_I18n,
} from "~/api/metrics/enums";

interface BusinessTransactionsCountCardProps {
  title?: string;
  onUpdate: (
    queryParams: MetricsAPI.GetBusinessTransactionsQuery
  ) => Promise<MetricsAPI.BusinessTransactionCountDto | undefined>;
}

const BusinessTransactionsCountCard = ({
  title,
  onUpdate,
}: BusinessTransactionsCountCardProps) => {
  const { t } = useTranslation(["enums"]);
  const { hasAll } = usePermissions();
  const [filter, setFilter] = useState(BUSINESS_TRANSACTIONS_FILTER.ALL);
  const [filterOptions, setFilterOptions] = useState<
    { label: string; value: any }[]
  >([]);

  useEffect(() => {
    setFilterOptions([
      {
        label: t(
          BUSINESS_TRANSACTIONS_FILTER_I18n[BUSINESS_TRANSACTIONS_FILTER.ALL]
        ),
        value: BUSINESS_TRANSACTIONS_FILTER.ALL,
      },
      {
        label: t(
          BUSINESS_TRANSACTIONS_FILTER_I18n[
            BUSINESS_TRANSACTIONS_FILTER.COMPLETED
          ]
        ),
        value: BUSINESS_TRANSACTIONS_FILTER.COMPLETED,
      },
      {
        label: t(
          BUSINESS_TRANSACTIONS_FILTER_I18n[
            BUSINESS_TRANSACTIONS_FILTER.FAILED_BY_CLIENT
          ]
        ),
        value: BUSINESS_TRANSACTIONS_FILTER.FAILED_BY_CLIENT,
      },
      {
        label: t(
          BUSINESS_TRANSACTIONS_FILTER_I18n[
            BUSINESS_TRANSACTIONS_FILTER.FAILED_BY_INTERNAL
          ]
        ),
        value: BUSINESS_TRANSACTIONS_FILTER.FAILED_BY_INTERNAL,
      },
    ]);
  }, [t]);

  if (!hasAll(PERMISSION.READ_BUSINESS_TRANSACTIONS_METRICS)) return null;

  return (
    <Grid item lg={12} xl={6}>
      <BaseCard
        title={title || "Business Transaction Counts"}
        timeIntervals={[eTimeInterval.LAST_HOUR, eTimeInterval.LAST_24_HOURS]}
        onUpdate={onUpdate}
        extraParams={{ filter }}
        extra={
          <Select
            variant="outlined"
            value={filter}
            options={filterOptions}
            onChange={(e) =>
              setFilter(
                e.target.value as MetricsAPI.eBusinessTransactionsFilter
              )
            }
          />
        }
      >
        {(data) =>
          data ? (
            <BusinessTransactionCount period={data.period} list={data.list} />
          ) : null
        }
      </BaseCard>
    </Grid>
  );
};

export default BusinessTransactionsCountCard;
